import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconFiletypeXls = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={100}
      height={114.483}
      viewBox="0 0 26.458 30.29"
      className="block w-full h-full fill-current"
    >
      <path
        d="M3.544 27.993l-.038-2.158-1.68-.195-1.678-.195V11.011l1.679-.195 1.679-.195.036-5.242.036-5.243H19.68l3.323 3.325 3.322 3.325v23.366H3.581z"
        fill="#fff"
      />
      <path
        d="M12.478 26.453v-1.234h4.934v2.467h-4.934zm6.168 0v-1.234h4.934v2.467h-4.934zm-6.168-3.701v-1.234h4.934v2.467h-4.934zm6.168 0v-1.234h4.934v2.467h-4.934zm-6.168-3.7v-1.234h4.934v2.467h-4.934zm6.168 0v-1.234h4.934v2.467h-4.934zm-6.168-3.701v-1.234h4.934v2.467h-4.934zm6.168 0v-1.234h4.934v2.467h-4.934zm-6.168-3.7v-1.234h4.934v2.467h-4.934zm6.168 0v-1.234h4.934v2.467h-4.934zm-6.168-3.702V6.716h4.934v2.467h-4.934zm6.168 0c0-1.224-.009-1.233-.009-1.233l2.755.01h2.193l-.005.401v2.056h-4.934z"
        fill="#83bc9d"
      />
      <path
        d="M3.415 25.791c-.007-1.858.1-2.583.274-2.583.173 0 .155 3.008.155 4.684v1.987H26.047V7.069h-1.263l-1.2.02v-.362l2.388-.011-3.144-3.151L19.742.482V1.75c0 1.034.022 1.291.022 1.291s-.433.204-.433 1.209c0 1.005.43.911.43.911l.01 1.603-.425-.037-.016-1.247-.664.004s-.02-.01-.02-1.234.01-1.224.01-1.224l.674-.004.001-2.61H3.844v5.071c0 4.417.058 6.716-.121 6.716-.18 0-.317 1.137-.308-3.462L3.432 0h16.244l3.391 3.393 3.391 3.393V30.29H3.432zm2.908 1.105l-.013-1.281 1.419.479c.603.087 1.88-.123 2.4.31l1.116.49v.792H6.336zM6.31 7.95V6.716h4.934v2.467H6.31zm0-3.7V3.015h4.934v2.467H6.31zm6.167 0V3.015h4.934v2.467h-4.934z"
        fill="#969696"
      />
      <path
        d="M11.382 26.904c-.264-.029-1.436-.175-2.604-.325L3.5 25.9C1.767 25.677 0 25.472 0 25.472s.006-1.524.006-7.243c0-5.127.008-7.242.008-7.242S11.21 9.615 11.76 9.52l.445-.076v8.778c0 6.942-.036 8.773-.036 8.773s-.522-.063-.786-.092zM8.229 21.19c.029.01-.307-.714-.684-1.52l-.684-1.464.493-1.05c.271-.579.58-1.252.686-1.497l.193-.445H7.61l-.607-.002-.86 1.99-.346-.926-.424-1.04-.626-.014-.664.013.388.904c.188.436.48 1.088.639 1.454l.288.666-.64 1.493-.64 1.424h.587l.554.016.45-1.06.384-.976.176.393c.098.216.668 1.62.668 1.62l.586.008s.64-.01.668 0zM19.351 7.088l-.005-.362h4.238v.362zm-.02-2.84c0-1.004.038-1.233.206-1.233.167 0 .205.229.205 1.234s-.038 1.233-.205 1.233c-.168 0-.206-.228-.206-1.233z"
        fill="#1f7145"
      />
      <g>
        <path fill="#5f5f5f" d="M19.33 3.02h.434V5.48h-.434z" />
      </g>
    </svg>,
  );
IconFiletypeXls.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconFiletypeXls;
